import {
  CountryCode,
  Currency,
  Language,
  StoreId,
} from "@ubnt/store.core/lib/types";

// #############################################################################
// Stores info
// #############################################################################
export const STORE_INFO_USA = {
  id: StoreId.Us,
  defaultCurrency: Currency.Usd,
  countries: [
    CountryCode.Us,
    CountryCode.Pr,
    CountryCode.Pw,
    CountryCode.Gu,
    CountryCode.As,
    CountryCode.Vi,
    CountryCode.Mp,
    CountryCode.Mh,
    CountryCode.Fm,
  ],
  // label: "USA Store",
};

/**
 * USA store is always the first item and is always present
 */
export const STORE_INFO_MAPPING = [
  STORE_INFO_USA,
  {
    id: StoreId.Eu,
    defaultCurrency: Currency.Eur,
    countries: [
      CountryCode.At,
      CountryCode.Be,
      CountryCode.Bg,
      CountryCode.Hr,
      CountryCode.Cy,
      CountryCode.Cz,
      CountryCode.Dk,
      CountryCode.Ee,
      CountryCode.Fi,
      CountryCode.Fr,
      CountryCode.De,
      CountryCode.Gr,
      CountryCode.Es,
      CountryCode.Hu,
      CountryCode.Is,
      CountryCode.Ie,
      CountryCode.It,
      CountryCode.Lv,
      CountryCode.Li,
      CountryCode.Lt,
      CountryCode.Lu,
      CountryCode.Mt,
      CountryCode.Mc,
      CountryCode.Nl,
      CountryCode.No,
      CountryCode.Pl,
      CountryCode.Pt,
      CountryCode.Ro,
      CountryCode.Rs,
      CountryCode.Sk,
      CountryCode.Si,
      CountryCode.Se,
      CountryCode.Ch,
      CountryCode.Ax,
      CountryCode.Ad,
      CountryCode.Ba,
      CountryCode.Fo,
    ],
    // label: "Europe Store",
  },
  {
    id: StoreId.Ca,
    defaultCurrency: Currency.Cad,
    countries: [CountryCode.Ca],
    // label: "Canada Store",
  },
  {
    id: StoreId.Me,
    defaultCurrency: Currency.Aed,
    countries: [CountryCode.Ae],
    // label: "Middle East Store",
  },
  {
    id: StoreId.Za,
    defaultCurrency: Currency.Zar,
    countries: [CountryCode.Za],
    // label: "South Africa Store",
  },
  {
    id: StoreId.Uk,
    defaultCurrency: Currency.Gbp,
    countries: [CountryCode.Gb, CountryCode.Im, CountryCode.Gg, CountryCode.Je],
    // label: "United Kingdom Store",
  },
  {
    id: StoreId.Sg,
    defaultCurrency: Currency.Sgd,
    countries: [CountryCode.Sg],
    // label: "Singapore Store",
  },
  {
    id: StoreId.In,
    defaultCurrency: Currency.Inr,
    countries: [CountryCode.In],
    // label: "India Store",
  },
  {
    id: StoreId.Jp,
    defaultCurrency: Currency.Jpy,
    countries: [CountryCode.Jp],
  },
  {
    id: StoreId.Br,
    defaultCurrency: Currency.Brl,
    countries: [CountryCode.Br],
  },
  {
    id: StoreId.Tw,
    defaultCurrency: Currency.Twd,
    countries: [CountryCode.Tw],
  },
  {
    id: StoreId.Ph,
    defaultCurrency: Currency.Php,
    countries: [CountryCode.Ph],
  },
  {
    id: StoreId.Mx,
    defaultCurrency: Currency.Mxn,
    countries: [CountryCode.Mx],
  },
];

// #############################################################################
// Languages
// #############################################################################
export const COUNTRY_LANGUAGE_MAPPING: [Language, Set<CountryCode>][] = [
  [
    Language.EsEs,
    new Set([
      CountryCode.Es,
      CountryCode.Co,
      CountryCode.Ar,
      CountryCode.Cr,
    ]),
  ],
  [Language.It, new Set([CountryCode.It])],
  [Language.El, new Set([CountryCode.Gr])],
  [Language.EsMx, new Set([CountryCode.Mx])],
  [Language.PtPt, new Set([CountryCode.Pt])],
  [Language.PtBr, new Set([CountryCode.Br])],
  [
    Language.Ar,
    new Set([CountryCode.Sa, CountryCode.Jo, CountryCode.Qa, CountryCode.Ae]),
  ],
  [Language.Fr, new Set([CountryCode.Fr])],
  [Language.El, new Set([CountryCode.Gr])],
  [Language.Ja, new Set([CountryCode.Jp])],
  [Language.It, new Set([CountryCode.It])],
  [Language.De, new Set([CountryCode.De])],
  [Language.Zh, new Set([CountryCode.Cn])],
  [Language.Tw, new Set([CountryCode.Tw])],
  [Language.Cs, new Set([CountryCode.Cz])],
  [Language.Da, new Set([CountryCode.Dk])],
  [Language.Nl, new Set([CountryCode.Nl])],
  [Language.Ko, new Set([CountryCode.Kr])],
  [Language.No, new Set([CountryCode.No])],
  [Language.Pl, new Set([CountryCode.Pl])],
  [Language.Ru, new Set([CountryCode.Ru, CountryCode.By, CountryCode.Kg, CountryCode.Kz])],
  [Language.Sv, new Set([CountryCode.Se])],
  [Language.Tr, new Set([CountryCode.Tr])]
];
